import { render } from "./base-status-badge.vue?vue&type=template&id=6d24439f&ts=true"
import script from "./base-status-badge.vue?vue&type=script&lang=ts"
export * from "./base-status-badge.vue?vue&type=script&lang=ts"

import "./base-status-badge.vue?vue&type=style&index=0&id=6d24439f&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__